import React from "react";
import { FaPlay } from "react-icons/fa";

const Header = ({ cuerrentVideo, setplaying, playing }) => {
  console.log("playing===>", playing);
  console.log("video===>", cuerrentVideo);
  return (
    <>
      {playing ? (
        <video
          src={cuerrentVideo.sources}
          width="100%"
          height="100%"
          controls
        ></video>
      ) : (
        <div
          className="header-1"
          style={{
            backgroundImage: `url(${cuerrentVideo.thumb})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            width: "100%",
            height: "100%",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <div className="header_inner">
                  <h3>{cuerrentVideo.subtitle}</h3>
                  <h1 className="pt-3">{cuerrentVideo.title}</h1>
                  <p>{cuerrentVideo.description}</p>
                </div>
              </div>
              <div className="col-md-3">
                <div class="container">
                  <div className="pause_button">
                    <div class="bg_1"></div>
                    <div class="button-1">
                      <FaPlay
                        className="button_1"
                        onClick={() => setplaying(true)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
